import { createSelector } from 'reselect';

const getHeaders = state => state.header;

export const getSearchHeaders = createSelector([getHeaders], headers => headers.search ?? {});
